import React, { useEffect } from 'react';
import './css/App.css';
import { useDispatch, useSelector } from 'react-redux';
import { setInterval as setPlannedInterval, getAllPlans } from './store/PlannedItemStore';
import moment from 'moment';
import ReceptionHome from "./components/reception/ReceptionHome";
import Login from "./components/Login";

const Home = () => {
    const dispatch = useDispatch();
    const orgId = useSelector(state => state.authState.orgId);

    useEffect(() => {
        dispatch(setPlannedInterval({ start: moment().startOf('day').valueOf(), end: moment().add(5, 'days').startOf('day').valueOf() }));
        dispatch(getAllPlans());

        const updateDates = setInterval(() => {
            dispatch(setPlannedInterval({ start: moment().startOf('day').valueOf(), end: moment().add(5, 'days').startOf('day').valueOf() }));
        }, 1000 * 180);

        return () => {
            clearInterval(updateDates);
        };
    }, [dispatch]);

    if (!orgId) return <Login />;

    return (
        <div className="App">
            <ReceptionHome />
        </div>
    );
};

export default Home;
